import { IPagination } from './../interfaces';

/**
 * generate pagination object
 */
export const getPagination = (_currentPage: number, _itemsPerPage: number, _itemsNumber: number, _range: number) : IPagination => {
    const itemsNumber = Number(_itemsNumber) || 0;
    let itemsPerPage = Number.isInteger(_itemsPerPage) ? Number(_itemsPerPage) : itemsNumber;

    if(itemsPerPage === 0){
        itemsPerPage = itemsNumber;
    }

    const pagesNumber = itemsPerPage === 0 ? 0 : Math.ceil(itemsNumber/itemsPerPage);

    // validate current page
    let currentPage = Number(_currentPage) || 0;

    if(currentPage > pagesNumber - 1){
        currentPage = 0;
    }

    const start = currentPage * itemsPerPage;
    let end = start + itemsPerPage;

    // validate the end
    if(end > itemsNumber){
        end = itemsNumber;
    }

    const prevPage = currentPage <= 0 ? 0 : currentPage - 1;
    const nextPage = pagesNumber === 0 ? 0 : (currentPage >= pagesNumber - 1 ? pagesNumber - 1 : currentPage + 1);

    const range = Number(_range) || 10;

    const halfRange = Math.ceil((range - 1) / 2);
    let rangeStart = currentPage - halfRange;
    let rangeEnd = Math.min(rangeStart + range - 1, pagesNumber - 1);

    if(rangeStart <= 0){
        rangeStart = 0;
        rangeEnd = Math.min(range - 1, pagesNumber - 1);
    }

    if(rangeEnd >= pagesNumber - 1){
        rangeStart = Math.max(pagesNumber - range, 0);
        rangeEnd = pagesNumber - 1;
    }

    return {
        itemsNumber,
        itemsPerPage,
        pagesNumber,
        currentPage,
        start,
        end,
        prevPage,
        nextPage,
        range,
        rangeStart,
        rangeEnd,
    }
};
